import moment from 'moment';
import { Invoice } from 'shared/classes/Billing';
import { GIFT_CARD_STATUSES } from 'shared/common/constants';
import { Modal } from 'bootstrap';

function RefundCode(data = {}){
	var self = this;
	self.type = "RefundCode"

    self.rootvm = data.rootvm;

	self.gift_card_uuid = ko.observable(data.gift_card_uuid);
    self.prefix = ko.pureComputed(() => 'RC-');
    self.code = ko.observable(data.code);
    self.gift_amount = ko.observable(data.gift_amount);
    self.redeemed_amount = ko.observable(data.redeemed_amount);
    self.currency = ko.observable(data.currency);
    self.fee_number = ko.observable(undefined);
    self.gift_card_status = ko.observable(data.status);

    self.inserted = ko.observable(new moment(data.inserted));
    self.expiration_date = ko.observable(new moment(data.expiration_date));

    self.extra_notes = ko.observable(data.extra_notes);
    self.new_extra_notes = ko.observable(data.extra_notes);
    self.editing_extra_notes = ko.observable(false);
    self.cancel_extra_notes = function(){

        self.new_extra_notes(self.extra_notes());
        self.editing_extra_notes(false);
    }

    self.save_extra_notes = function(){

        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/gift-card/extra-notes',
            type: 'POST',
            data:ko.toJSON({
                gift_card_uuid: self.gift_card_uuid(),
                extra_notes: self.new_extra_notes()
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){

                   self.extra_notes(data.extra_notes);
                   self.new_extra_notes(data.extra_notes);
                   self.editing_extra_notes(false);
                   notyf.success("Saved!");
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            },
            complete: function(){
            }
        });
    };

    self.redeemed_invoices = ko.observableArray([]);
    self.lookup_redeemed_invoices = function(){

        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/gift-card/invoices',
            type: 'GET',
            data:{
                gift_card_uuid: self.gift_card_uuid()
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.redeemed_invoices(ko.utils.arrayMap( data.gift_card.redeemed_invoices || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new Invoice(x);
                    }));

            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    self.is_valid = ko.pureComputed(() => {
        return self.code() && self.gift_amount() && self.fee_number()
    });
};

export function RefundCodeViewModel(data) {
    var self = this;
    self.type = "RefundCodeViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = function(){
        if (!self.initialized()){
          self.lookup_refund_codes().then(function(){
                console.log('done looking up refund codes');
                self.initialized(true);
          })};
    }

    self.new_refund_code = ko.observable(new RefundCode());
    self.refund_codes = ko.observableArray([]);

    self.GIFT_CARD_STATUSES = GIFT_CARD_STATUSES;

    self.filter_gift_card_status = ko.observable();
    self.filtered_refund_codes = ko.pureComputed(() => 
        self.refund_codes().filter(code => 
            !self.filter_gift_card_status() || 
            code.gift_card_status() === self.filter_gift_card_status()
        )
    );


    self.selected_rc_info = ko.observable(new RefundCode());
    self.lookup_invoices_for_rc = (rc) => {
        self.selected_rc_info(rc);
        self.selected_rc_info().lookup_redeemed_invoices().then(() => {
            const rcInfoModal = document.getElementById('rcInfoModal');
            Modal.getOrCreateInstance(rcInfoModal).show();
        });
    };

    self.add_click = function(){
        const url = '/api/admin/refund-code'
        const data = {
            code: self.new_refund_code().prefix() + self.new_refund_code().code(),
            fee_number: self.new_refund_code().fee_number(),
            gift_amount: self.new_refund_code().gift_amount(),
            currency: self.new_refund_code().currency(),
        }
        const request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        });

        return fetch(request)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    data.refund_code.rootvm = self.rootvm;
                    self.refund_codes.unshift(new RefundCode(data.refund_code));
                    self.new_refund_code(new RefundCode());
                    notyf.success("Added!");
                } else {
                    notyf.error(data.message);
                }
            })
            .catch(error => {
                notyf.error(error);
                console.log(error);
            });
    }

    self.lookup_refund_codes = function(){
        self.rootvm.is_busy(true);
        const url = self.rootvm.web_host + '/api/admin/gift-cards'
        const params = new URLSearchParams({
            product_type: 'refund',
            offset: 0,
            limit: 0
        })
        const request = new Request(
            url + '?' + params.toString(), {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        });

        return fetch(request)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    self.refund_codes(data.gift_cards.map(refund_code => {
                        refund_code.rootvm = self.rootvm;
                        return new RefundCode(refund_code);
                    }));
                } else {
                    notyf.error(data.message);
                }
            })
            .catch(error => {
                notyf.error(error);
                console.log(error);
            }).finally(() => {
                self.rootvm.is_busy(false)
            });
    };
};
